import { createContext, useContext, useMemo } from "react";

/**
 * @param {object} apacConfigurationsData - Raw entry from Contentful.
 * @returns {object} Merged translations config (empty object if none found).
 */

const ApacConfigurationsContext = createContext({
  apacConfigurationsData: {},
  translations: {},
});

export const ApacConfigurationsProvider = ({
  apacConfigurationsData = {},
  children,
}) => {
  const value = useMemo(
    () => ({
      apacConfigurationsData,
    }),
    [apacConfigurationsData] // Added dataList dependency
  );

  return (
    <ApacConfigurationsContext.Provider value={value}>
      {children}
    </ApacConfigurationsContext.Provider>
  );
};

export const useApacConfigurations = () =>
  useContext(ApacConfigurationsContext).apacConfigurationsData;
export const useContentfulTranslations = () =>
  useContext(ApacConfigurationsContext).apacConfigurationsData;
